export default __webpack_public_path__ + "static/media/avatar_3.d8c05085.png";